/** Independent jobs over the existing single-input editors, not a Model's array-input capability. */
export const WORKSPACE_BATCH_TOOL_IDS = [
  'img-fast-upscale',
  'image-enlarger',
  'image-enhancer',
  'image-sharpener',
  'hd-image-converter',
  'img-remove-bg',
  'img-photo-restore',
  'unblur-image',
  'watermark-remover',
  'ai-shadow-remover',
  'remove-text-from-image',
  'unpixelate-image',
] as const;

const batchTools = new Set<string>(WORKSPACE_BATCH_TOOL_IDS);
export function supportsWorkspaceBatchProcessing(toolId: string) {
  return batchTools.has(toolId);
}
